import React, { Component } from 'react';
import { connect } from 'react-redux'

import { updateClassInfo } from '../../../../stores/actions/classAction';

class EditExtraInfo extends Component {

    constructor(props){
        super(props)
        this.state = {
            extraInfoId:'',
            extraInfoData:[],

            loc_link:'',
            loc_detail:[],
            extra_info: [],

            loc_detail_data:'',
            extra_info_data:'',

            isLoading:null,
            message:null
        }
        this.baseState = this.state 
    }

    static getDerivedStateFromProps (nextProps, prevState) { 

        let update = [];

        if (nextProps.extraInfoData && nextProps.extraInfoData.id !== prevState.extraInfoId) {
            update.extraInfoData = nextProps.extraInfoData;
            update.extraInfoId = nextProps.extraInfoData.id;
        }
        
        return update;
    }
    
    componentDidUpdate = (prevProps, prevState) => {  

        const { extraInfoData, updateClassInfoError, updateClassInfoSuccess } = this.props;

        if((extraInfoData && extraInfoData.id) !== (prevProps.extraInfoData && prevProps.extraInfoData.id)){
            this.setState({
                loc_link: this.state.extraInfoData.loc_link,
                loc_detail: this.state.extraInfoData.loc_detail,
                extra_info: this.state.extraInfoData.extra_info,
            });
        }

        if(prevProps.updateClassInfoError !== updateClassInfoError) {
            this.setState({
                isLoading: false,
                message: {
                    msg: updateClassInfoError.message,
                    type: updateClassInfoError.type,
                }
            })
        }

        if(prevProps.updateClassInfoSuccess !== updateClassInfoSuccess) {
            this.setState({
                isLoading: false,
                message: {
                    msg: updateClassInfoSuccess.message,
                    type: updateClassInfoSuccess.type,
                },
            }, () => {
                setTimeout(() => { 
                    this.props.hideModal();
                    setTimeout(() => { 
                        this.setState({message: null})
                    }, 2000);
                }, 2000);
            })
        }
    } 

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleArray = (id, type) => {
        const { extra_info, loc_detail, loc_detail_data, extra_info_data } = this.state;

        //add
        if (type === "e_loc_detail" && loc_detail_data !== "") {
            this.setState({ loc_detail:[...loc_detail, loc_detail_data] })

            document.getElementById('e_loc_detail').value = "";
            this.setState({loc_detail_data: ''})

        } else if (type === "e_extra_info" && extra_info_data !== "") {
            this.setState({ extra_info:[...extra_info, extra_info_data] })

            document.getElementById('e_extra_info').value = "";
            this.setState({extra_info_data: ''})

        } else if (type === "") {

        //delete
        } else if (type === "loc-del" ) {
            let data = loc_detail && loc_detail.filter(d => { return d !== id; })
            this.setState({ loc_detail: data })

        } else if (type === "extra-del" ) {
            let data = extra_info && extra_info.filter(d => { return d !== id; })
            this.setState({ extra_info: data })

        } else return null

    }

    submit = () => {
        var result = window.confirm("Confirm add?");
    
        if (result) {
            this.setState({
                isLoading: true
            })

            this.props.updateClassInfo(this.state, this.state.extraInfoId)
        }

    }

    render () {

        const { message, isLoading } = this.state;
        const { loc_detail, extra_info } = this.state;

        return (

            <div>

                <b className="uppercase middle">
                    Add Practical Session Extra Info
                    <div className="title-border"></div>
                </b>

                <div className='mb-4'>
                    <b>Location link:</b>
                    <input id="loc_link" placeholder='Location link' onChange={this.handleChange} value={this.state.loc_link} type="text" className="form-control" />
                </div>

                <div>
                    <b>Location info:</b>
                    <div className='row pl-3 pr-3'>
                        <input id="e_loc_detail"  onChange={(e) => this.setState({loc_detail_data: e.target.value})} type="text" className='col m-0 form-control' placeholder="Location detail" /> 
                        <button 
                            onClick={this.handleArray.bind(this, null, 'e_loc_detail')}
                            style={{borderRadius:"2px"}} 
                            className='btn btn-primary'>Add
                        </button>
                    </div>

                    <ul>
                        { loc_detail && loc_detail.map((d,i) => {
                            return (
                                <li key={i}>{d} {' '}
                                    <span onClick={this.handleArray.bind(this, d, 'loc-del')}><i className='fas fa-times text-danger' /></span>
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div className='mt-2'>
                    <b>Extra info:</b>
                    <div className='row pl-3 pr-3'>
                        <input id="e_extra_info"  onChange={(e) => this.setState({extra_info_data: e.target.value})} type="text" className='col m-0 form-control' placeholder="Extra info" /> 
                        <span 
                            onClick={this.handleArray.bind(this, null, 'e_extra_info')}
                            style={{borderRadius:"2px"}} 
                            className='btn btn-primary'>Add
                        </span>
                    </div>

                    <ul>
                        { extra_info && extra_info.map((d,i) => {
                            return (
                                <li key={i}>{d} {' '}
                                    <span onClick={this.handleArray.bind(this, d, 'extra-del')}><i className='fas fa-times text-danger' /></span>
                                </li>
                            )
                        })}
                    </ul>

                </div>
                
                { isLoading === true ? 
                    <small>Loading...</small>
                : 
                    message  ?
                        <small className={message.type === 'updateClassInfoError' ? "text-red" : message.type === 'updateClassInfoSuccess'  ? "text-green" : null }>
                            {message.msg}
                        </small>
                    : null
                }

                <button className='m-1 mt-4 float-right text-white all-btn bg-success' onClick={this.submit.bind(this)}>Save {' '}<i className='fas fa-check-circle' /></button>

            </div>

        )
    }
}



const mapStateToProps = (state) => {
    return {
        updateClassInfoError: state.classes.updateClassInfoError,
        updateClassInfoSuccess: state.classes.updateClassInfoSuccess,
    }
  }
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateClassInfo: (data, extraInfoId) => dispatch(updateClassInfo(data, extraInfoId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditExtraInfo);
